export class PipChecklistElement {
    public text?: string;
    public checked?: boolean;
}
